import { render } from "./SimulationSmallCard.vue?vue&type=template&id=92e89aea&scoped=true&ts=true"
import script from "./SimulationSmallCard.vue?vue&type=script&lang=ts"
export * from "./SimulationSmallCard.vue?vue&type=script&lang=ts"

import "./SimulationSmallCard.vue?vue&type=style&index=0&id=92e89aea&lang=scss&scoped=true"

import exportComponent from "/builds/Chirbou/isolation/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92e89aea"]])

export default __exports__